var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinkSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16345 0 16 0H17C25.8366 0 33 7.16344 33 16C33 24.8366 25.8366 32 17 32H16C7.16345 32 0 24.8366 0 16Z",
    fill: "#FF1493"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_319_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8412 21.0753L19.1443 17.3784C19.8604 16.4939 20.2916 15.3699 20.2916 14.1458C20.2916 11.3086 17.983 9 15.1458 9C12.3085 9 10 11.3085 10 14.1458C10 16.983 12.3086 19.2916 15.1458 19.2916C16.3699 19.2916 17.4939 18.8604 18.3784 18.1443L22.0753 21.8412C22.1809 21.9468 22.3195 21.9999 22.4582 21.9999C22.5969 21.9999 22.7356 21.9468 22.8412 21.8412C23.053 21.6294 23.053 21.287 22.8412 21.0753ZM15.1458 18.2082C12.9055 18.2082 11.0833 16.3861 11.0833 14.1458C11.0833 11.9054 12.9055 10.0833 15.1458 10.0833C17.3861 10.0833 19.2083 11.9054 19.2083 14.1458C19.2083 16.3861 17.3861 18.2082 15.1458 18.2082Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_319_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(10 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkSearch);
export default __webpack_public_path__ + "static/media/pink-search.f534d118983bfae168466c4a8a3b81cd.svg";
export { ForwardRef as ReactComponent };